import {Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {CommonService} from "../common/common.service";
import {AbstractControl, FormArray, FormControl, FormGroup, Validators} from "@angular/forms";
import {ActivatedRoute, Params, Router} from "@angular/router";
import {debounceTime, pairwise} from "rxjs/internal/operators";
import {HttpClient} from "@angular/common/http";
import {connectApi} from "../common/connect-api";
import {CustomHttpParams} from "../common/connect-http-interceptor";
import {Referral} from "./referral";
import {ReferralForm} from "./referral-form";
import {ConfirmDialogService} from "../common/confirm-dialog/confirm-dialog.service";
import {dropDowns} from "../shared/drop-downs";
import {IDUtil} from "../common/id-util";
import {getFormValidationErrors} from "../common/get-form-validation-errors";
import {Utils} from "../common/utils";
import {ConnectDialog} from "../common/confirm-dialog/connect-dialog";
import {RxFormMapper} from "rx-form-mapper";
import {ReferredClient} from "./referred-client";
import {DpConnectAutoSuggestComponent} from "../common/auto-suggest/dp-connect-auto-suggest.component";
import {Contact} from "../common/contact";
import {StaffProfiles} from "../common/model/staff-profiles";
import {Telephone} from "../shared/telephone";
import {formatDate} from "@angular/common";
import {ReferralDocument} from './referral-document';
//import {Messages} from '../shared/messages';
import {FileUploadService} from '../common/file-upload/file-upload.service';
import {Messages} from '../shared/messages';
import {DpAutoSuggestService} from "../common/auto-suggest/dp-auto-suggest.service";
import {AutoSuggest} from "../common/auto-suggest/dp-auto-suggest";
import {TABLETMIN} from "../shared/constants";


@Component({
    selector: 'dp-referral-form',
    templateUrl: './referral-form.component.html'
})
export class ReferralFormComponent implements OnInit, OnDestroy {

    formGroup: FormGroup;
    referral: Referral;
    agentRoleOptions: any = dropDowns.agentRoleOptions;
    clientRoleOptions: any = [];
    purchaseOf: any = dropDowns.purchaseOf;
    transactionType: any = dropDowns.transactionType;
    solicitorListByFirm: Contact[] = [];
    isSolicitorDropDownMode: boolean = false;
    isReferralCompleteOrDeclineOrSubmitted: boolean = false;
    showSubmitReferralButton: boolean;
    otherSideSolicitorAutoSuggestList : AutoSuggest[];
    @ViewChild('receivingLawFirmNameAutoSuggest') receivingLawFirmNameAutoSuggest: DpConnectAutoSuggestComponent;
    @ViewChild('otherLawFirmNameAutoSuggest') otherLawFirmNameAutoSuggest: DpConnectAutoSuggestComponent;
    @ViewChild('pageContent') pageContent : ElementRef;
    @ViewChild('backToTopBtn') backToTopBtn: ElementRef;

    referralDocuments: ReferralDocument[] = [];
    scheduler : any;
    isReferralAddedAsParticipant: boolean;
    routerState: any;


    dropDownOptions: AutoSuggest[] = [];

    constructor(private  rxFormMapper: RxFormMapper,
                private commonService: CommonService,
                private router: Router,
                private route: ActivatedRoute,
                private httpClient: HttpClient,
                private fileUploadService: FileUploadService,
                private  dpAutoSuggestService: DpAutoSuggestService,
                private confirmDialogService: ConfirmDialogService) {
        this.routerState = this.router.getCurrentNavigation() && this.router.getCurrentNavigation().extras ? this.router.getCurrentNavigation().extras.state : undefined;

    }

    ngOnInit() {
         this.isReferralAddedAsParticipant = this.routerState && this.routerState.isReferralAddedAsParticipant;
            this.route
            .params
            .subscribe((params: Params) => {
                setTimeout(() => {
                    this.setUpReferral(params['id']);
                }, 100);

            });

    }

    async setUpReferral(id: number): Promise<void> {
        if (!!id && id > 0) {
            let result = await   this.httpClient.get<Referral>(connectApi.getReferrals + id).toPromise();
            if (result && !!result['Referral']) {
                this.referral = new Referral(result['Referral']);
                this.referral.formData = undefined;
                if (!this.commonService.cachedLoggedInStaffProfile) {
                    await this.commonService.getCachedLoggedInStaffProfile().toPromise();
                }

            }
            else {
                await this.createNewReferral(id);
            }
            this.createFormGroup();
            this.startPolling();
        }
        else {
            await this.createNewReferral(id);
            this.createFormGroup();
        }
    }

    async createNewReferral(id: number): Promise<void> {
        this.referral = new Referral();
        this.referral.id = id;
        this.referral.status = 'DRAFT';
        this.referral.referralForm = new ReferralForm();
        let staffProfile: StaffProfiles = await this.commonService.getCachedLoggedInStaffProfile().toPromise();
        if (staffProfile && staffProfile.contact) {
            if (staffProfile && staffProfile.contact.contactName) {
                this.referral.referralForm.referringAgentFirstName = staffProfile.contact.contactName.firstName ? staffProfile.contact.contactName.firstName : '';
                this.referral.referralForm.referringAgentMiddleName = staffProfile.contact.contactName.middleName ? staffProfile.contact.contactName.middleName : '';
                this.referral.referralForm.referringAgentLastName = staffProfile.contact.contactName.lastName ? staffProfile.contact.contactName.lastName : '';
            }
            this.referral.referralForm.referringAgentEmail = staffProfile.contact.email ? staffProfile.contact.email : '';
            this.referral.referralForm.referringAgentRole = staffProfile.contact.contactType ? staffProfile.contact.contactType : 'USER_CLIENT';
            this.referral.referralForm.referringAgentCompany = staffProfile.contact.companyName ? staffProfile.contact.companyName : '';
            if (this.referral.referralForm.referringAgentTelephones && this.referral.referralForm.referringAgentTelephones.length > 0 && staffProfile.contact.telephone) {
                let telephone: Telephone = staffProfile.contact.telephone.find(item => !!item.isWorkPhone);
                if (telephone && !!telephone.telephoneNumber) {
                    this.referral.referralForm.referringAgentTelephones[0].telephoneNumber = telephone.telephoneNumber;
                }
            }
        }
    }

    createFormGroup(): void {
        this.formGroup = this.rxFormMapper.writeForm(this.referral);
        this.formGroup['controls'].referralForm.get('receivingSolicitorAddress').disable();
        this.addReferredClientValidation();
        this.transactionTypeUpdate();
        this.updateFormStatus();
        this.formGroup.valueChanges.pipe(
            debounceTime(1000),
            pairwise()
        ).subscribe(() => {
            this.saveReferral();
        });


    }

    addReferredClientValidation(): void {
        let referredClientArray: FormControl[] = this.formGroup['controls'].referralForm['controls'].referredClients['controls'];
        referredClientArray.forEach(referredClient => {
            if (!(!!referredClient.get('telephones')['controls'].find(item => !!item.value.telephoneNumber) || !!referredClient.get("email").value)) {
                referredClient.get('email').setValidators(Validators.compose([Validators.required, Validators.pattern(Utils.EMAIL_ADDRESS_PATTERN)]));
                Utils.setFieldAsRequired(referredClient.get('telephones')['controls'][0].get('telephoneNumber'));
            }

        })
    }

    get formatterSubmissionText(): string {
        if (this.referral && this.referral.referralForm) {
            if (this.referral.status === 'DECLINED' || this.referral.status === 'ACCEPTED') {
                return 'This referral was ' + this.referral.status.toLowerCase() + (this.referral.lastUpdatedTimeStamp ? (' on ' + formatDate(this.referral.lastUpdatedTimeStamp, 'dd MMM yyyy @h:mm a', 'en')) : '') + '. It cannot be modified anymore.';
            } else {
                return 'You have submitted this referral ' + (this.referral.referralForm.submissionDate ? ('on ' + formatDate(this.referral.referralForm.submissionDate, 'dd MMM yyyy @h:mm a', 'en')) : '') + '. It cannot be modified anymore.';
            }
        } else {
            return '';
        }
    }

    updateFormStatus(): void {
        if ((this.referral.isAccepted() || this.referral.isDeclined() || this.referral.isSubmitted()) && !this.isReferralCompleteOrDeclineOrSubmitted) {
            this.isReferralCompleteOrDeclineOrSubmitted = true;
            this.formGroup.disable();
        } else {
            this.showSubmitReferralButton = true;
        }
    }


    async saveReferral(): Promise<boolean> {
        // Create Referral object from from group control object
        let referralObj: Referral = this.commonService.updateFormObject(this.formGroup, Referral, this.referral);
        // Cleanup coverts referral form object to form data json string
        // It also copies lawyer and law firm from referral from to its parent referral object.

        referralObj.cleanUpReferral();
        // we verify that it should target law firm
        if (referralObj.targetCustomerAccountId) {
            if (referralObj.id > 0) {
                // Update Referral
                try {
                    let response = await this.httpClient.put<Referral>(connectApi.updateReferrals + '/' + referralObj.id, referralObj, {
                        params: new CustomHttpParams(true)
                    }).toPromise();
                    if (response && response['Referral']) {
                        // if operation was successful then update FormStatus
                        this.updateFormStatus();
                        // Also Update any Staff Profile Changes
                        this.commonService.updatedLoggedInStaffProfile(referralObj.referralForm);
                        return Promise.resolve(true);
                    }
                }
                catch (e) {
                    return Promise.resolve(false);
                }
            }
            else {
                // Create Referral
                referralObj.id = Number(IDUtil.getID());
                try {
                    let response = await this.httpClient.post<Referral>(connectApi.updateReferrals, referralObj, {
                        params: new CustomHttpParams(true)
                    }).toPromise();
                    if (response && response['Referral']) {
                        // if operation was successful then update FormStatus
                        this.updateFormStatus();
                        // Also Update any Staff Profile Changes
                        this.commonService.updatedLoggedInStaffProfile(referralObj.referralForm);
                        // update new generate id back on to object and form control
                        this.referral.id = response['Referral'].id;
                        this.formGroup.controls.id.setValue(response['Referral'].id);
                        return Promise.resolve(true);
                    }
                } catch (e) {
                    return Promise.resolve(false);
                }

            }
        }


    }

    async submitReferral(): Promise<void> {

        // check for validation errors ...
        let hasErrors: boolean = getFormValidationErrors(this.formGroup.controls).length > 0;
        let targetCustomerAccountId = this.formGroup['controls'].referralForm.get('receivingLawFirmId').value;
        // we verify two things first its should target law firm and other form errors.
        if (!targetCustomerAccountId || hasErrors) {
            Utils.invokeFieldLevelValidation(this.formGroup);
            let connectDialog = new ConnectDialog();
            connectDialog.message = 'Your Referral Request has incomplete information, please complete all required information before submitting your request'
            connectDialog.dialogType = 'ERROR';
            connectDialog.showCancelBtn = false;
            this.confirmDialogService.confirmDialog(connectDialog).subscribe();
        }
        else {
            // Update submission Date and update stauts
            this.formGroup['controls'].referralForm.get('submissionDate').setValue(new Date().getTime());
            this.formGroup.get('status').setValue('SUBMITTED');
            let isReferralUpdate = await this.saveReferral();
            // if update is successful show confirm dialog
            if (isReferralUpdate) {
                this.showConfirmDialog();
            }
        }

    }

    showConfirmDialog(): void {
        let connectDialog = new ConnectDialog();
        connectDialog.message = 'Your Referral Request has been successfully submitted'
        connectDialog.dialogType = 'SUCCESS';
        connectDialog.showCancelBtn = false;
        this.confirmDialogService.confirmDialog(connectDialog).subscribe();
    }

    async backToHomePage(): Promise<void> {
        if (this.referral && !this.referral.isSubmitted()) {
            await this.saveReferral();
            let connectDialog = new ConnectDialog();
            connectDialog.message = 'Your data has been saved. Do you also want to submit your referral at this time?';
            connectDialog.okBtnText = 'Submit';
            connectDialog.cancelBtnText = 'Not Now';
            connectDialog.dialogType = 'SUCCESS';
            connectDialog.showCancelBtn = true;
            let result = await this.confirmDialogService.confirmDialog(connectDialog).toPromise();
            if (!!result) {
                this.submitReferral();
            }
            else {
                this.router.navigate(['./home']);
            }
        }



    }

    removeValidation(formGroup: FormGroup): void {
        if (!!formGroup.get('telephones')['controls'].find(item => !!item.value.telephoneNumber) || !!formGroup.get("email").value) {
            formGroup.get('email').setValidators(Validators.pattern(Utils.EMAIL_ADDRESS_PATTERN));
            formGroup.get('email').updateValueAndValidity();
            formGroup.get('telephones')['controls'][0].get('telephoneNumber').setValidators(null);
            formGroup.get('telephones')['controls'][0].get('telephoneNumber').updateValueAndValidity();
        }
        else {
            formGroup.get('email').setValidators(Validators.compose([Validators.required, Validators.pattern(Utils.EMAIL_ADDRESS_PATTERN)]));
            formGroup.get('email').updateValueAndValidity();
            formGroup.get('telephones')['controls'][0].get('telephoneNumber').setValidators(Validators.required);
            formGroup.get('telephones')['controls'][0].get('telephoneNumber').updateValueAndValidity();
        }
    }

    addNewClientInfo(): void {
        let referredClient = new ReferredClient();
        if (this.isPurchase()) {
            referredClient.role = 'BUYER';
        }
        else if (this.isSale()) {
            referredClient.role = 'SELLER';
        }
        else {
            referredClient.role = 'OWNER';
        }
        referredClient.id = IDUtil.getID();
        let formGroup = this.rxFormMapper.writeForm(referredClient);
        let referredClientArray = (this.formGroup['controls'].referralForm['controls'].referredClients['controls'] as FormArray);
        if (!(!!formGroup.get('telephones')['controls'].find(item => !!item.value.telephoneNumber) || !!formGroup.get("email").value)) {
            formGroup.get('email').setValidators(Validators.compose([Validators.required, Validators.pattern(Utils.EMAIL_ADDRESS_PATTERN)]));
            Utils.setFieldAsRequired(formGroup.get('telephones')['controls'][0].get('telephoneNumber'));
        }
        referredClientArray.push(formGroup);
        this.formGroup['controls'].referralForm.patchValue("referredClients", referredClientArray);
    }


    deleteClient(formGroup: FormGroup): void {
        let connectDialog = new ConnectDialog();
        connectDialog.message = 'Are you sure you want to delete this information?'
        connectDialog.dialogType = 'WARNING';
        this.confirmDialogService.confirmDialog(connectDialog).subscribe(
            res => {
                if (res) {
                    let referredClientArray: FormControl[] = this.formGroup['controls'].referralForm['controls'].referredClients['controls'];
                    let formControlIndex: number = referredClientArray.findIndex(item => item.get('id').value == formGroup.get('id').value);
                    if (this.referral.referralForm.referredClients) {
                        let index: number = this.referral.referralForm.referredClients.findIndex(item => item.id == formGroup.get('id').value);
                        if (index > -1) {
                            this.referral.referralForm.referredClients.splice(index, 1);
                        }
                    }
                    if (formControlIndex > -1) {
                        referredClientArray.splice(formControlIndex, 1);
                        this.formGroup['controls'].referralForm.patchValue("referredClients", referredClientArray);
                    }
                }
            }
        )
    }

    getClientHeaderInfo(referredClientIndex: number): string {
        let referredClientArray = (this.formGroup['controls'].referralForm['controls'].referredClients['controls'] as FormArray);
        if (referredClientIndex < referredClientArray.length) {
            return (referredClientArray[referredClientIndex].value.firstName ? referredClientArray[referredClientIndex].value.firstName : '') + ' ' + (referredClientArray[referredClientIndex].value.lastName ? referredClientArray[referredClientIndex].value.lastName : '')
        }
        else {
            return '';
        }
    }


    getClientFormGroup(referredClientIndex: number): FormGroup {
        let referredClientArray = (this.formGroup['controls'].referralForm['controls'].referredClients['controls'] as FormArray);
        if (referredClientIndex < referredClientArray.length) {
            return referredClientArray[referredClientIndex];
        }
        else {
            return undefined;
        }
    }

    getPropertyAddressFormGroup(): any {
        return this.formGroup['controls'].referralForm;
    }

    accountSelected(event: any) {
        this.formGroup['controls'].referralForm.get('receivingSolicitorId').setValue(undefined);
        this.formGroup['controls'].referralForm.get('receivingSolicitorName').setValue('');
        this.formGroup['controls'].referralForm.get('receivingSolicitorAddress').setValue('');
        this.isSolicitorDropDownMode = true;
        if (event && event.value == 'NO_RECORD_FOUND') {
            this.formGroup['controls'].referralForm.patchValue({receivingLawFirmId: undefined});
            this.formGroup['controls'].referralForm.patchValue({receivingLawFirmName: ''});
            this.isSolicitorDropDownMode = false;
        }
        else {
            if (event && event.value) {
                this.formGroup['controls'].referralForm.patchValue({receivingLawFirmId: event.value});
                this.solicitorListByFirm = [];
                if (event && event.object && !!event.object.legalFirmId) {
                    if (event.object.mailingAddress) {
                        this.formGroup['controls'].referralForm.patchValue({receivingSolicitorAddress: event.object.mailingAddress.fullAddress});
                    }

                    this.commonService.getSolicitorsForLawFirm(event.object.legalFirmId).subscribe(contacts => {
                        this.solicitorListByFirm = contacts;
                    })
                }
            }
            else {
                this.formGroup['controls'].referralForm.patchValue({receivingLawFirmId: undefined});
                this.isSolicitorDropDownMode = false;
            }
            if (event && event.displayName) {
                this.formGroup['controls'].referralForm.patchValue({receivingLawFirmName: event.displayName});
            } else {
                this.formGroup['controls'].referralForm.patchValue({receivingLawFirmName: ''});
            }
        }
    }

    contactSelected(event: any, controlId: string, controlName: string) {
        if (event && event.value == 'NO_RECORD_FOUND') {

            this.formGroup['controls'].referralForm.get(controlId).setValue(undefined);
            this.formGroup['controls'].referralForm.get(controlName).setValue('');
        }
        else {
            if (event && event.value) {
                this.formGroup['controls'].referralForm.get(controlId).setValue(event.value);

            }
            else {
                this.formGroup['controls'].referralForm.get(controlId).setValue(undefined);
            }
            if (event && event.displayName != undefined && event.displayName != null) {
                this.formGroup['controls'].referralForm.get(controlName).setValue(event.displayName);
            }
            else {
                this.formGroup['controls'].referralForm.get(controlName).setValue('');
            }
        }


        if (controlId == 'receivingSolicitorId') {
            if (event && event.object && !!event.object.customerAccountId) {
                this.receivingLawFirmNameAutoSuggest.setDefaultAutoSuggestValue(event.object.firmName);
                this.formGroup['controls'].referralForm.patchValue({receivingLawFirmId: event.object.customerAccountId});
                this.formGroup['controls'].referralForm.patchValue({receivingLawFirmName: event.object.firmName});
                if (event.object.mailingAddress && event.object.mailingAddress.sameAsAddressTypeCode == 'CUSTOMER_ACCOUNT') {
                    this.formGroup['controls'].referralForm.patchValue({receivingSolicitorAddress: event.object.mailingAddress.fullAddress});
                }
                else {
                    this.formGroup['controls'].referralForm.patchValue({receivingSolicitorAddress: ''});
                }
            }
        }

        if (controlId == 'otherSolicitorId') {
            if (event && event.object && !!event.object.legalFirmId) {
                //Clean otherLawFirm drop down. we only have one law firm.
                this.otherSideSolicitorAutoSuggestList = [];
                this.otherLawFirmNameAutoSuggest.setDefaultAutoSuggestValue(event.object.firmName);
                //The legalFirmId of solicitor is the law firm id which this solicitor belongs to
                this.formGroup['controls'].referralForm.get('otherLawFirmId').setValue(event.object.legalFirmId);
                this.formGroup['controls'].referralForm.get('otherLawFirmName').setValue(event.object.firmName);
                // Set SOLICITOR drop down list
                this.dpAutoSuggestService.getAutoSuggestList('','SOLICITOR', this.getOtherLawFirmId()).subscribe(autoSuggest => {
                    this.otherSideSolicitorAutoSuggestList = autoSuggest;
                });
            }
        }

        if(controlId == 'otherLawFirmId') {
            //If law firm is changed, it should clean solicitor and set drop down list related to the new law firm
            this.formGroup['controls'].referralForm.get('otherSolicitorId').setValue(undefined);
            this.formGroup['controls'].referralForm.get('otherSolicitorName').setValue('');
            this.otherSideSolicitorAutoSuggestList = [];

            if(this.getOtherLawFirmId()) {
                this.dpAutoSuggestService.getAutoSuggestList('', 'SOLICITOR', this.getOtherLawFirmId()).subscribe(autoSuggest => {
                    this.otherSideSolicitorAutoSuggestList = autoSuggest;

                });
            }
        }
    }


    isPurchase(): boolean {
        return this.formGroup['controls'].referralForm.get('transactionType').value == 'PURCHASE';
    }

    isSale(): boolean {
        return this.formGroup['controls'].referralForm.get('transactionType').value == 'SALE';
    }

    isMortgage(): boolean {
        return this.formGroup['controls'].referralForm.get('transactionType').value == 'REFINANCE';
    }

    updateSolicitorName(event): void {
        let id = this.formGroup['controls']?.referralForm?.get('receivingSolicitorId');
        if (id && id.value && this.solicitorListByFirm) {
            let contact = this.solicitorListByFirm.find(item => item.id == id.value);
            if (contact) {
                this.formGroup['controls'].referralForm.get('receivingSolicitorName').setValue(contact.fullName);
            }
        }
    }

    transactionTypeUpdate(event?: any): void {
        let transactionType = this.formGroup['controls']?.referralForm?.get('transactionType')?.value;
        if (this.isPurchase() || this.isSale()) {
            this.clientRoleOptions = dropDowns.clientRoleOptionsP_S;
        }
        else {
            this.clientRoleOptions = dropDowns.clientRoleOptionsM;
        }
        if (!!transactionType) {
            let referredClientArray: FormControl[] = this.formGroup['controls'].referralForm['controls'].referredClients['controls'];
            if (referredClientArray && referredClientArray.length > 0) {
                referredClientArray.forEach(referredClient => {
                    if (this.isPurchase()) {
                        referredClient.patchValue({"role": "BUYER"});
                    }
                    else if (this.isSale()) {
                        referredClient.patchValue({"role": "SELLER"});
                    }
                    else {
                        referredClient.patchValue({"role": "OWNER"});
                    }
                })
            }
        }
    }

    documentUploaded(event) {
        this.startPolling();
    }

    deleteDocument(document: ReferralDocument) {
        const connectDialog = new ConnectDialog();
        connectDialog.message = Messages.areYouSureYouWantToDeleteThisDocument;
        connectDialog.dialogType = 'WARNING';
        this.confirmDialogService.confirmDialog(connectDialog).subscribe(
            res => {
                if (res) {
                    this.fileUploadService.deleteReferralDocument(this.referral.id, String(document.id))
                        .subscribe((res)=>{
                            this.startPolling();
                        });
                }
            }
        );
    }

    public startPolling(): void {
        this.getReferralDocuments();
        clearInterval(this.scheduler);
        this.scheduler = setInterval(() => {
            this.getReferralDocuments();
        }, 5000);
    }

    stopPolling() : void {
        window.clearInterval(this.scheduler);
    }

    getReferralDocuments() : void {
        this.fileUploadService.getReferralDocuments(this.referral.id).subscribe(
            (documents)=>{
                this.referralDocuments = documents.filter(doc => !doc.sourceId);
                if(Array.isArray(this.referralDocuments) && (this.referralDocuments.length == 0 || this.referralDocuments.every( doc => doc.isVirusClean()))){
                    this.stopPolling();
                }
            })
    }

    // save new Referral as the id is needed to upload documents
    prepareTransactionBeforeUpload(){
        if (this.referral.id < 0) {
            this.saveReferral();
        }
    }

    ngOnDestroy(): void {
        this.stopPolling();
    }

    get emailPattern(){
        return Utils.EMAIL_ADDRESS_PATTERN;
    }

    returnToOverview() : void {
        this.router.navigate(['./home/matter-summary-home']);
    }

    getOtherLawFirmId(): number{
        return this.formGroup['controls'].referralForm.get('otherLawFirmId').value;
    }

    getOtherSolicitorName(): string{
        return this.formGroup['controls'].referralForm.get('otherSolicitorName').value;
    }

    onScrollEvent() {
        Utils.toggleBackToTopBtnVisibility(this.pageContent, this.backToTopBtn)
    }

    backToTop() {
        Utils.backToTop(this.pageContent);
    }


}

export function RequireMatch(control: AbstractControl) {
    const selection: any = control.value;
    if (typeof selection === 'string') {
        return {incorrect: true};
    }
    return null;
}

